import { apiClient } from './apiClient';
import { Stage, StageCreateDto, StageUpdateDto } from '../../types/types';

const BASE_URL = '/stage';

export const stageService = {
    getAllStages: async (): Promise<Stage[]> => {
        const response = await apiClient.get<Stage[]>(`${BASE_URL}/all`);
        return response.data;
    },

    getActiveStages: async (): Promise<Stage[]> => {
        const response = await apiClient.get<Stage[]>(`${BASE_URL}/active`);
        return response.data;
    },

    getStageById: async (id: string): Promise<Stage> => {
        const response = await apiClient.get<Stage>(`${BASE_URL}/${id}`);
        return response.data;
    },

    getStagesWithCounts: async (): Promise<Stage[]> => {
        const response = await apiClient.get<Stage[]>(`${BASE_URL}/with-counts`);
        return response.data;
    },

    getCandidateCountsByStage: async (): Promise<Record<string, number>> => {
        const response = await apiClient.get<Record<string, number>>(`${BASE_URL}/candidate-counts`);
        return response.data;
    },

    getStagesRequiringEmail: async (): Promise<Stage[]> => {
        const response = await apiClient.get<Stage[]>(`${BASE_URL}/requiring-email`);
        return response.data;
    },

    getAutoAdvancingStages: async (): Promise<Stage[]> => {
        const response = await apiClient.get<Stage[]>(`${BASE_URL}/auto-advancing`);
        return response.data;
    },

    createStage: async (stage: StageCreateDto): Promise<Stage> => {
        const response = await apiClient.post<Stage>(BASE_URL, stage);
        return response.data;
    },

    updateStage: async (id: string, stage: StageUpdateDto): Promise<Stage> => {
        const response = await apiClient.put<Stage>(`${BASE_URL}/${id}`, stage);
        return response.data;
    },

    deleteStage: async (id: string): Promise<void> => {
        await apiClient.delete(`${BASE_URL}/${id}`);
    }
};